import { useState, useEffect, use, useMemo } from "react";
import DoctorCard from "./DoctorCards";
import { FaCheck, FaTimes, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import "./DoctorsGridPageCss/GridMainSection.css";
import doctors from "../../DB/DoctorsDetails";
import DoctorsGridFirstSection from "./DoctorGridFirstSection";
import useIsMobile from "../../Hooks/IsmobileHook";

import { downloadAllDoctorsInOneCSV } from "./downloadDoctors";
import toast from "react-hot-toast";
import {
  getBranchList,
  getDoctorList,
  getFilterData,
  getSpeciality,
} from "../../api/api";
import CustomPagination from "../../common/CustomPagination";
import { Autocomplete, Button, TextField, Chip } from "@mui/material";
import OPdListPdf from "./OPdListPdf";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../common/loader/CustomLoader";
import { useDoctor } from "../../Contexts/Doctor.contexts";
import { FaFilter } from "react-icons/fa6";

import { PiStethoscopeBold } from "react-icons/pi";
import { MdFileDownload } from "react-icons/md";
import doctorDefault from "../../Assets/doctor_default_copy.jpeg";
import DoctorSkeleton from "../../common/loader/DoctorSkeleton";
import { useDispatch, useSelector } from "react-redux";
import {
  setOpdBranchList,
  setOPdDoctorList,
} from "../../store/slices/doctorGridSlice";
import VirtulizedDoctorGrid from "./VirtulizedDoctorGrid";
import { getDateInString, getWeekDayName } from "../../utils/helper";

export default function GridMainSection() {
  const dispatch = useDispatch();
  const opdDoctorState = useSelector((state) => state.doctorGrid);
  const cacheOpdDoctorList = opdDoctorState.opdDoctorList;
  const cacheOpdBranchList = opdDoctorState.opdBranchList;
  const isMobile = useIsMobile();

  const [price, setPrice] = useState(10000);
  const [currentPage, setCurrentPage] = useState(1);
  const [showMoreSpecialties, setShowMoreSpecialties] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [sortBy, setSortBy] = useState("");

  const [searchFilters, setSearchFilters] = useState({
    doctorName: "",
    department: "",
    branch: "",
  });
  const [debouncedSearchFilters, setDebouncedSearchFilters] =
    useState(searchFilters);

  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState("");
  const [selectedExperience, setSelectedExperience] = useState("");
  // const [selectedConsultations, setSelectedConsultations] = useState([]);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState([]);

  const [doctorList, setDoctorList] = useState([]);
  const [location, setLocation] = useState([]);
  const [allSpecialties, setAllSpecialties] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { doctorListData, setDoctorListData } = useDoctor();
  const [isOpen, setIsOpen] = useState(false);
  const [filterPayload, setFilterPayload] = useState({});
  const [specializationData, setSpecializationData] = useState([]);
  const [originalDoctorList, setOriginalDoctorList] = useState([]);
  const [selectedConsultations, setSelectedConsultations] = useState({});
  // Filters that were actually applied (updated only when user clicks Apply)
  const [appliedFilters, setAppliedFilters] = useState({
    selectedSpecialties: [],
    selectedCenter: [],
    selectedGenders: "",
    selectedExperience: "",
    selectedConsultations: {},
    selectedRatings: [],
    searchFilters: { doctorName: "", department: "", branch: "" },
    sortBy: "",
  });

  const hasActiveFilters = () => {
    const af = appliedFilters || {};
    return (
      (af.selectedSpecialties && af.selectedSpecialties.length > 0) ||
      (af.selectedCenter && af.selectedCenter.length > 0) ||
      (af.selectedGenders && af.selectedGenders !== "") ||
      (af.selectedExperience && af.selectedExperience !== "") ||
      (af.selectedConsultations &&
        Object.keys(af.selectedConsultations).length > 0) ||
      (af.selectedRatings && af.selectedRatings.length > 0) ||
      (af.sortBy && af.sortBy !== "") ||
      (af.searchFilters &&
        (af.searchFilters.doctorName ||
          af.searchFilters.department ||
          af.searchFilters.branch))
    );
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);
  //       await Promise.all([
  //         fetchDoctorList(),
  //         fetchBranch(),
  //         fetchSpeciality(),
  //       ]);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const hasCachedDoctors = cacheOpdDoctorList?.length > 0;
        const hasCachedBranches = cacheOpdBranchList?.length > 0;

        setLoading(true);

        if (hasActiveFilters()) {
          // Always fetch fresh when applying filters
          await Promise.all([
            fetchDoctorList(),
            !hasCachedBranches ? fetchBranch() : Promise.resolve(),
            fetchSpeciality(),
          ]);
        } else {
          // No filters
          const promises = [];

          if (!hasCachedDoctors) promises.push(fetchDoctorList());
          if (!hasCachedBranches) promises.push(fetchBranch());
          promises.push(fetchSpeciality());

          await Promise.all(promises);

          if (hasCachedDoctors && hasCachedBranches) {
            const specialtyList = Array.from(
              new Map(
                cacheOpdDoctorList.map((doc) => [
                  doc.specialization_id,
                  { id: doc.specialization_id, name: doc.specialization },
                ])
              ).values()
            ).sort((a, b) => a.name?.localeCompare(b.name));
            setAllSpecialties(specialtyList);
            setDoctorList(cacheOpdDoctorList);
            setLocation(cacheOpdBranchList);
            setDoctorListData(cacheOpdDoctorList);
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const fetchBranch = async () => {
    try {
      setLoading(true);
      const res = await getBranchList();
      const branchData = res?.data?.data || [];
      setLocation(branchData);
      dispatch(setOpdBranchList(branchData));
    } catch (error) {
      console.error("Error fetching Branch list:", error);
    }
  };

  const fetchDoctorList = async () => {
    try {
      const today = new Date();

      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = today.getFullYear();

      const todayDate = `${day}-${month}-${year}`;

      const payload = {
        today: getWeekDayName(0),
        nextday: getWeekDayName(1),
        sex: "",
        feesOrder: "",
        expInYears: "",
        online: "N",
        fromDate: todayDate,
      };
      setLoading(true);
      const response = await getDoctorList(payload);
      console.log("it is response of dr", response);

      if (response?.data?.status === "Succesful") {
        const filteredDoctorData = response?.data?.data.filter(
          (doc) => doc.OnlineBooking !== "N"
        );
        const specialtyList = Array.from(
          new Map(
            filteredDoctorData.map((doc) => [
              doc.specialization_id,
              { id: doc.specialization_id, name: doc.specialization },
            ])
          ).values()
        ).sort((a, b) => a.name?.localeCompare(b.name));
        setAllSpecialties(specialtyList);
        setDoctorList(filteredDoctorData);
        setOriginalDoctorList(filteredDoctorData);
        dispatch(setOPdDoctorList(filteredDoctorData));
        setDoctorListData(filteredDoctorData); //context api store
      }
    } catch (error) {
      toast.error("Failed to fetch doctor list");
      console.error("Error fetching doctor list:", error);
    }
  };

  const fetchSpeciality = async () => {
    try {
      setLoading(true);
      const response = await getSpeciality();
      console.log("it is response of speciality", response);

      if (response?.data?.status === "Succesful") {
        const specialtyData = response?.data?.data || [];
        setSpecializationData(specialtyData);
      }
    } catch (error) {
      console.error("Error fetching specialty data:", error);
    }
  };

  const genderOptions = [
    { label: "Male", value: "M" },
    { label: "Female", value: "F" },
  ];

  const experienceData = [
    { label: "5", value: "exp1" },
    { label: "10", value: "exp2" },
    { label: "15", value: "exp3" },
    { label: "20", value: "exp4" },
  ];

  const consultationData = [
    { label: "Today", value: "Online" },
    { label: "Tomorrow", value: "Offline" },
    { label: "Home Visit", value: "Offline" },
    { label: "Video Consult", value: "Offline" },
  ];
  const handleConsultationChange = (label, checked) => {
    setSelectedConsultations((prev) => {
      const updated = { ...prev };

      if (!checked) {
        delete updated[label];
        return updated;
      }

      if (label === "Today") {
        updated[label] = getWeekDayName(0);
      } else if (label === "Tomorrow") {
        updated[label] = getWeekDayName(1);
      } else if (label === "Video Consult") {
        updated[label] = "Y";
      } else {
        updated[label] = "N";
      }

      return updated;
    });
  };

  // const allSpecialties = Array.from(
  //   new Map(
  //     doctorList.map((doc) => [
  //       doc.specialization_id,
  //       { id: doc.specialization_id, name: doc.specialization },
  //     ])
  //   ).values()
  // ).sort((a, b) => a.name?.localeCompare(b.name));
  // console.log("all specialties", allSpecialties);

  // const displayedSpecialties = showMoreSpecialties
  //   ? allSpecialties
  //   : allSpecialties.slice(0, 7);

  // const [openFilters, setOpenFilters] = useState({
  //   specialties: true,
  //   gender: false,
  //   availability: false,
  //   pricing: false,
  //   experience: false,
  //   consultation: false,
  //   rating: false,
  // });

  // const toggleFilter = (key) => {
  //   setOpenFilters((prev) => ({ ...prev, [key]: !prev[key] }));
  // };

  const toggleSelection = (value, selectedList, setSelectedList) => {
    if (selectedList.includes(value)) {
      setSelectedList(selectedList.filter((item) => item !== value));
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  const handleClearAll = () => {
    setLocation(cacheOpdBranchList);
    setSelectedSpecialties([]);
    setSelectedCenter([]);
    setSelectedGenders("");
    setSelectedExperience("");
    setSelectedConsultations([]);
    setSelectedRatings([]);
    setSearchFilters({ doctorName: "", department: "", branch: "" });
    setPrice(10000);
    setIsChecked(false);
    setSortBy("");
    setFilterPayload({});
    // Clear applied filters snapshot as well
    setAppliedFilters({
      selectedSpecialties: [],
      selectedCenter: [],
      selectedGenders: "",
      selectedExperience: "",
      selectedConsultations: {},
      selectedRatings: [],
      searchFilters: { doctorName: "", department: "", branch: "" },
      sortBy: "",
    });

    setDoctorList(originalDoctorList);
    if (cacheOpdDoctorList && cacheOpdDoctorList.length > 0) {
      setDoctorList(cacheOpdDoctorList);
      setDoctorListData(cacheOpdDoctorList);
    }
  };

  const doctorsPerPage = 12;

  // const filteredDoctors = doctorList.filter((doc) => {
  //   const matchesName = searchFilters.doctorName
  //     ? doc?.doctor_name
  //         ?.toLowerCase()
  //         .includes(searchFilters.doctorName.toLowerCase())
  //     : true;

  //   const matchesDept = searchFilters.department
  //     ? String(doc?.specialization_id) === String(searchFilters.department)
  //     : true;

  //   const matchesBranch = searchFilters.branch
  //     ? doc?.centers?.some(
  //         (center) => center?.center_id === Number(searchFilters.branch)
  //       )
  //     : true;

  //   return matchesName && matchesDept && matchesBranch;
  // });

  const filteredDoctors = useMemo(() => {
    return doctorList.filter((doc) => {
      const matchName = doc.doctor_name
        ?.toLowerCase()
        .includes(searchFilters.doctorName.toLowerCase());

      const matchDept = searchFilters.department
        ? String(doc.specialization_id) === String(searchFilters.department)
        : true;

      const matchBranch = searchFilters.branch
        ? doc?.centers?.some(
            (center) => center?.center_id === Number(searchFilters.branch)
          )
        : true;

      return matchName && matchDept && matchBranch;
    });
  }, [doctorList, searchFilters]);

  const totalPages = Math.ceil(filteredDoctors.length / doctorsPerPage);
  const indexOfLastDoctor = currentPage * doctorsPerPage;
  const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage;
  const currentDoctors = filteredDoctors.slice(
    indexOfFirstDoctor,
    indexOfLastDoctor
  );

  const [showOpdModal, setshowOpdMOdal] = useState(false);

  console.log("current dr list", doctorList);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleDownload = () => {
    // downloadAllDoctorsInOneCSV(doctors);
    setshowOpdMOdal(true);
  };

  const handleApplyFilters = async (sortValue) => {
    const appliedSort = sortValue ?? sortBy;
    const payload = {
      center_id: selectedCenter.join(","),
      specialization_id: selectedSpecialties.join(","),
      today: selectedConsultations["Today"] || "",
      nextday: selectedConsultations["Tomorrow"] || "",
      selectFilterFlag: "applyFilter",
      fromDate: getDateInString(new Date()),
      sex: selectedGenders,
      expInYears: selectedExperience,
      online: selectedConsultations["Video Consult"] || "",
      feesOrder: appliedSort,
    };
    try {
      setLoading(true);
      let response;
      if (selectedCenter.length === 0 && selectedSpecialties.length === 0) {
        response = await getDoctorList(payload);
      } else {
        response = await getFilterData(payload);
      }
      const status = (response?.data?.status || "").toLowerCase();
     if (status === "success" || status === "succesful") {
        setDoctorList(response?.data?.data || []);
      }
      console.log("Filtered doctors response:", response);
    } catch (error) {
      console.error("Error applying filters:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleApplyFilters();
  }, [appliedFilters]);

  // Helpers for chips
  const getSpecialtyName = (id) => {
    const found = allSpecialties.find((s) => String(s.id) === String(id));
    return found ? found.name : id;
  };

  const getCenterName = (id) => {
    const found = location.find((c) => String(c.center_id) === String(id));
    return found ? found.center_name : id;
  };

  const getExperienceLabel = (value) => {
    const found = experienceData.find((e) => e.value === value);
    return found ? `${found.label}+ years` : value;
  };

  const clearFilter = (type, value) => {
    switch (type) {
      case "specialty":
        setSelectedSpecialties((prev) => {
          const next = prev.filter((i) => String(i) !== String(value));
          setAppliedFilters((ap) => ({ ...ap, selectedSpecialties: next }));
          // Re-apply filters immediately after removing an applied filter
          // setTimeout(() => handleApplyFilters(), 1000);
          return next;
        });
        break;
      case "center":
        setSelectedCenter((prev) => {
          const next = prev.filter((i) => String(i) !== String(value));
          setAppliedFilters((ap) => ({ ...ap, selectedCenter: next }));
          // setTimeout(() => handleApplyFilters(), 0);
          return next;
        });
        break;
      case "gender":
        setSelectedGenders("");
        setAppliedFilters((ap) => ({ ...ap, selectedGenders: "" }));
        // setTimeout(() => handleApplyFilters(), 0);
        break;
      case "experience":
        setSelectedExperience("");
        setAppliedFilters((ap) => ({ ...ap, selectedExperience: "" }));
        // setTimeout(() => handleApplyFilters(), 0);
        break;
      case "consultation":
        setSelectedConsultations((prev) => {
          const copy = { ...prev };
          delete copy[value];
          setAppliedFilters((ap) => ({ ...ap, selectedConsultations: copy }));
          // setTimeout(() => handleApplyFilters(), 0);
          return copy;
        });
        break;
      case "rating":
        setSelectedRatings((prev) => {
          const next = prev.filter((r) => r !== value);
          setAppliedFilters((ap) => ({ ...ap, selectedRatings: next }));
          // setTimeout(() => handleApplyFilters(), 0);
          return next;
        });
        break;
      case "doctorName":
        setSearchFilters((prev) => ({ ...prev, doctorName: "" }));
        setAppliedFilters((ap) => ({
          ...ap,
          searchFilters: { ...ap.searchFilters, doctorName: "" },
        }));
        // setTimeout(() => handleApplyFilters(), 0);
        break;
      case "department":
        setSearchFilters((prev) => ({ ...prev, department: "" }));
        setAppliedFilters((ap) => ({
          ...ap,
          searchFilters: { ...ap.searchFilters, department: "" },
        }));
        // setTimeout(() => handleApplyFilters(), 0);
        break;
      case "branch":
        setSearchFilters((prev) => ({ ...prev, branch: "" }));
        setAppliedFilters((ap) => ({
          ...ap,
          searchFilters: { ...ap.searchFilters, branch: "" },
        }));
        // setTimeout(() => handleApplyFilters(), 0);
        break;
      case "sortBy":
        setSortBy("");
        setAppliedFilters((ap) => ({ ...ap, sortBy: "" }));
        // setTimeout(() => handleApplyFilters(), 0);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (Object.keys(filterPayload).length > 0) {
      handleApplyFilters();
    }
  }, [filterPayload]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    searchFilters,
    selectedSpecialties,
    selectedGenders,
    selectedExperience,
    selectedConsultations,
    selectedRatings,
    price,
    isChecked,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchFilters(debouncedSearchFilters);
    }, 300);
    return () => clearTimeout(handler);
  }, [debouncedSearchFilters]);

  const handleSearchFilters = ({ doctorName, department, branch }) => {
    setDebouncedSearchFilters({ doctorName, department, branch });
  };

  const doctorDirectory = () => {
    navigate("/doctorDirectory");
  };

  const [isTablet, setIsTablet] = useState(window.innerWidth <= 998.75);

  useEffect(() => {
    const handleResize = () => setIsTablet(window.innerWidth <= 998.75);
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* {loading && <CustomLoader />} */}

      <DoctorsGridFirstSection
        onSearch={handleSearchFilters}
        locations={location}
        setSelectedCenter={setSelectedCenter}
        selectedCenter={selectedCenter}
        setSpecializationData={setSpecializationData}
        specializationData={specializationData}
      />

      <div className="gridMainContainer">
         <div className="doctors-header-bar ">
            {/* <div className="showingDiv">
              <h3>
                Showing <span>{filteredDoctors.length}</span> Doctors For You
              </h3>
            </div> */}

            <div className="header-controls">
              <div>
                {/* Filter Icon */}
                <div className="filters-Section">
                  {/* <label htmlFor="sort-select">Filter:</label> */}
                  <button
                    onClick={() => setIsOpen(true)}
                    className="filter-btn"
                  >
                    Filter: <FaFilter className="filter-icon" />
                  </button>
                </div>

                {/* Selected Filters Chips */}
                {hasActiveFilters() && (
                  <div className="mui-selected-filters">
                    {(appliedFilters.selectedSpecialties || []).map((id) => (
                      <Chip
                        key={`spec-${id}`}
                        label={`Spec: ${getSpecialtyName(id)}`}
                        onDelete={() => clearFilter("specialty", id)}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    ))}

                    {(appliedFilters.selectedCenter || []).map((id) => (
                      <Chip
                        key={`center-${id}`}
                        label={`Center: ${getCenterName(id)}`}
                        onDelete={() => clearFilter("center", id)}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    ))}

                    {appliedFilters.selectedGenders && (
                      <Chip
                        label={`Gender: ${
                          appliedFilters.selectedGenders === "M"
                            ? "Male"
                            : "Female"
                        }`}
                        onDelete={() => clearFilter("gender")}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    )}

                    {appliedFilters.selectedExperience && (
                      <Chip
                        label={`Experience: ${getExperienceLabel(
                          appliedFilters.selectedExperience
                        )}`}
                        onDelete={() => clearFilter("experience")}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    )}

                    {Object.keys(
                      appliedFilters.selectedConsultations || {}
                    ).map((key) => (
                      <Chip
                        key={`cons-${key}`}
                        label={`Consult: ${key}`}
                        onDelete={() => clearFilter("consultation", key)}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    ))}

                    {(appliedFilters.selectedRatings || []).map((r) => (
                      <Chip
                        key={`rating-${r}`}
                        label={`${r} Star`}
                        onDelete={() => clearFilter("rating", r)}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    ))}

                    {appliedFilters.searchFilters?.doctorName && (
                      <Chip
                        label={`Name: ${appliedFilters.searchFilters.doctorName}`}
                        onDelete={() => clearFilter("doctorName")}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    )}

                    {appliedFilters.searchFilters?.department && (
                      <Chip
                        label={`Dept: ${getSpecialtyName(
                          appliedFilters.searchFilters.department
                        )}`}
                        onDelete={() => clearFilter("department")}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    )}

                    {appliedFilters.searchFilters?.branch && (
                      <Chip
                        label={`Branch: ${getCenterName(
                          appliedFilters.searchFilters.branch
                        )}`}
                        onDelete={() => clearFilter("branch")}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    )}

                    {appliedFilters.sortBy && (
                      <Chip
                        label={`Sort: ${
                          appliedFilters.sortBy === "1"
                            ? "Price ↑"
                            : appliedFilters.sortBy === "2"
                            ? "Price ↓"
                            : appliedFilters.sortBy
                        }`}
                        onDelete={() => clearFilter("sortBy")}
                        size={isMobile ? "small" : "medium"}
                        sx={{ marginRight: 1, marginBottom: 1 }}
                      />
                    )}

                    <Chip
                      label="Clear All"
                      onClick={() => handleClearAll()}
                      onDelete={() => handleClearAll()}
                      size={isMobile ? "small" : "medium"}
                      color="error"
                    />
                  </div>
                )}
              </div>

              {/* <label className="availability-switch">
                Availability
                <div
                  className={`slider ${isChecked ? "on" : ""}`}
                  onClick={() => setIsChecked(!isChecked)}
                >
                  {isChecked ? (
                    <FaCheck className="icon onIcon" />
                  ) : (
                    <FaTimes className="icon" />
                  )}
                </div>
              </label> */}

              <div className="sort-dropdown">
                <label htmlFor="sort-select">Sort By:</label>
                <select
                  id="sort-select"
                  value={sortBy}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setSortBy(newValue);
                    handleApplyFilters(newValue);
                  }}
                >
                  <option value="">Default</option>
                  <option value="1">Price (Ascending)</option>
                  <option value="2">Price (Descending)</option>
                  {/* <option value="rating">Rating</option> */}
                </select>
              </div>
            </div>
            <div
              className="opd-buttons"
              style={{ display: "flex", gap: "15px", marginBottom: "20px" }}
            >
              <button
                className="rbdButton"
                onClick={doctorDirectory}
                // onClick={handleDirectoryClick}
              >
                <span className="btn-text d-button">
                  <PiStethoscopeBold color="white" size={18} />{" "}
                  {isTablet ? "Directory" : "Doctor Directory"}
                </span>
              </button>

              <button className="rbdButton" onClick={handleDownload}>
                {" "}
                <span className="btn-text d-button">
                  <MdFileDownload color="white" size={18} />{" "}
                  {isTablet ? "Download" : "Download Doctor’s CSV"}
                </span>
              </button>
            </div>
          </div>
        <div className="mainPackageCardSection OPDCardSectioin mb-4 mb-t-0">
         
          {loading ? (
            [...Array(8)].map((_, i) => <DoctorSkeleton key={i} />)
          ) : filteredDoctors.length > 0 ? (
            currentDoctors.map((doc, idx) => (
              <DoctorCard key={idx} params={doc} />
            ))
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "30vh",
                fontSize: "2rem",
                color: "red",
                fontWeight: 500,
                gridColumn: "1 / -1",
              }}
            >
              No Data Found
            </div>
          )}

          {doctorList.length > 0 && (
            <div
              style={{
                gridColumn: "1 / -1",
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
      {/* Popup Modal */}
      {isOpen && (
        <div className="filter-overlay">
          <div className="filter-modal">
            <button
              onClick={() => setIsOpen(false)}
              className="close-btn-filter"
            >
              ✖
            </button>

            <h2 className="filter-title">Apply Filters</h2>

            <div className="filter-section">
              {/* <div className="filter-group"> */}

              <label>Location</label>
              <Autocomplete
                multiple
                disablePortal
                options={location} // your API array
                getOptionLabel={(option) => option?.center_name || ""}
                value={location.filter((loc) =>
                  selectedCenter.includes(loc.center_id)
                )}
                onChange={(event, newValue) => {
                  setSelectedCenter(newValue.map((loc) => loc.center_id)); // directly store array of selected ids
                }}
                disableCloseOnSelect
                sx={{
                  p: 0,
                  "& .MuiAutocomplete-root": { padding: 0 },
                }}
                PaperProps={{ sx: { p: 0, m: 0 } }}
                ListboxProps={{ sx: { p: 0, m: 0 } }}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.center_id} style={{ padding: 0 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        padding: "6px 8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedCenter.includes(option.center_id)}
                        readOnly
                      />
                      {option.center_name}
                    </div>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Locations"
                    placeholder="Search location"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        p: 0,
                        "& .MuiInputBase-input": { padding: "6px 8px" },
                      },
                    }}
                    inputProps={{
                      ...params.inputProps,
                      style: { padding: 0, margin: 0 },
                    }}
                  />
                )}
                fullWidth
              />
              <label>Specialties</label>

              {allSpecialties && allSpecialties.length > 0 ? (
                <Autocomplete
                  multiple
                  disablePortal
                  options={allSpecialties}
                  getOptionLabel={(option) => option.name || ""}
                  value={allSpecialties.filter((s) =>
                    selectedSpecialties.includes(s.id)
                  )}
                  onChange={(event, newValue) => {
                    // store only the ids in state (keeps existing code expecting ids)
                    setSelectedSpecialties(newValue.map((v) => v.id));
                  }}
                  disableCloseOnSelect
                  sx={{
                    // ensure the root has no extra padding
                    "& .MuiAutocomplete-root": { padding: 0 },
                    // shrink overall component padding
                    p: 0,
                  }}
                  PaperProps={{ sx: { p: 0, m: 0 } }}
                  ListboxProps={{ sx: { p: 0, m: 0 } }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props} style={{ padding: 0 }} key={option.id}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1rem",
                          padding: "6px 8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedSpecialties.includes(option.id)}
                          readOnly
                        />
                        {option.name}
                      </div>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select specialties"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          p: 0,
                          "& .MuiInputBase-input": { padding: "6px 8px" },
                        },
                      }}
                      inputProps={{
                        ...params.inputProps,
                        style: { padding: 0, margin: 0 },
                      }}
                    />
                  )}
                />
              ) : (
                <p>No specialties available</p>
              )}
              {/* </div> */}

              <div className="filter-group">
                <label>Gender</label>
                <div className="checkbox-group">
                  {genderOptions.map((gender) => (
                    <label key={gender.value}>
                      {/* <input
                            type="radio"
                            checked={selectedGenders.includes(gender.value)}
                            onChange={() =>
                              toggleSelection(
                                gender.value,
                                selectedGenders,
                                setSelectedGenders
                              )
                            }
                          /> */}
                      <input
                        type="radio"
                        name="gender"
                        checked={selectedGenders === gender.value}
                        onChange={() => setSelectedGenders(gender.value)}
                      />{" "}
                      {gender.label}
                    </label>
                  ))}
                </div>
              </div>

              <div className="filter-group">
                <label>Experience</label>
                <select
                  value={selectedExperience}
                  onChange={(e) => setSelectedExperience(e.target.value)}
                >
                  <option value="">Select experience</option>
                  {experienceData.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}+ years
                    </option>
                  ))}
                </select>
              </div>

              {/* <div className="filter-group">
                <label>Consultation Type</label>
                <select
                
                  value={selectedConsultations[0] || ""}
                  onChange={(e) =>
                    setSelectedConsultations(
                      e.target.value ? [e.target.value] : []
                    )
                  }
                >
                  <option value="">Select consultation type</option>
                  {[
                    "Audio Call",
                    "Video Call",
                    "Instant Counselling",
                    "Chat",
                  ].map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="filter-group">
                <label>Consultation Type</label>

                <div className="checkbox-group">
                  {consultationData.map((item) => (
                    <label key={item.label} className="checkbox-item">
                      <input
                        type="checkbox"
                        checked={!!selectedConsultations[item.label]}
                        onChange={(e) =>
                          handleConsultationChange(item.label, e.target.checked)
                        }
                      />
                      <span>{item.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* <div className="filter-group">
                <label>Rating</label>
                <div className="checkbox-group">
                  {[5, 4, 3, 2, 1].map((rating) => (
                    <label key={rating}>
                      <input
                        type="checkbox"
                        checked={selectedRatings.includes(rating)}
                        onChange={() =>
                          toggleSelection(
                            rating,
                            selectedRatings,
                            setSelectedRatings
                          )
                        }
                      />
                      {rating} Star
                    </label>
                  ))}
                </div>
              </div> */}
            </div>

            {/* Action Buttons */}
            <div className="filter-actions">
              <button
                onClick={() => {
                  handleClearAll();
                  setIsOpen(false);
                }}
                className="rbdButton reset-Btn"
              >
                <span className="btn-text">Reset</span>
              </button>
              <button
                onClick={() => {
                  const payload = {
                    center_id: selectedCenter.join(","),
                    specialization_id: selectedSpecialties.join(","),
                    today: "",
                    nextday: "",
                    feesOrder: "",
                    selectFilterFlag: "applyFilter",
                    fromDate: "",
                    sex: selectedGenders,
                    expInYears: selectedExperience,
                    online: "N",
                    feesOrder: sortBy, // appliedSort,
                  };
                  setFilterPayload(payload);
                  // Save a snapshot of currently selected filters as "applied"
                  setAppliedFilters({
                    selectedSpecialties: [...selectedSpecialties],
                    selectedCenter: [...selectedCenter],
                    selectedGenders,
                    selectedExperience,
                    selectedConsultations: { ...selectedConsultations },
                    selectedRatings: [...selectedRatings],
                    searchFilters: { ...searchFilters },
                    sortBy,
                  });
                  setIsOpen(false);
                }}
                className="rbdButton"
              >
                <span className="btn-text">Apply</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {showOpdModal && (
        <OPdListPdf
          setshowOpdMOdal={handleDownload}
          doctors={doctorList}
          onclose={() => setshowOpdMOdal(false)}
          location={location}
        />
      )}
    </>
  );
}
